// San Leone — Pitch Deck content (IT / EN / AR)
export const IMAGES = {
  cover_hero:
    "https://static.prod-images.emergentagent.com/jobs/21ca7533-2233-4668-89c1-80c01499727b/images/8d0e7f9b895157c1cab414752b80aa1cffd8995b6387d8d5a0b5cbce83213e63.jpeg",
  masterplan_mood:
    "https://static.prod-images.emergentagent.com/jobs/21ca7533-2233-4668-89c1-80c01499727b/images/d2a8605c2e63ca626037064a1d447a3350594b187b5ea2ea65236590a6c26509.jpeg",
  site_current:
    "https://static.prod-images.emergentagent.com/jobs/21ca7533-2233-4668-89c1-80c01499727b/images/5ef8720c400b822f2e849c894dde1ed2e9776afff1a11a58442c783ebf1c21bd.jpeg",
  bluezone_mood:
    "https://static.prod-images.emergentagent.com/jobs/21ca7533-2233-4668-89c1-80c01499727b/images/7d8fdfc42338f998be876129492b29866af13ea37e761ecf1cc4a075689c9ded.jpeg",
  longevity_clinic:
    "https://static.prod-images.emergentagent.com/jobs/21ca7533-2233-4668-89c1-80c01499727b/images/0366f5b01801a07a6bc2dccc826741f09d6e29b6c9aafe804d31270da765c20c.jpeg",
  boutique_hotel:
    "https://static.prod-images.emergentagent.com/jobs/21ca7533-2233-4668-89c1-80c01499727b/images/24676c8e1fd0cae81f8a42ae868570cef169bd0b9092722e2fe08130238ce305.jpeg",
  underground_spa:
    "https://static.prod-images.emergentagent.com/jobs/21ca7533-2233-4668-89c1-80c01499727b/images/a501c9bfa2bda7c9fab11a0bcbf5ee62ff2f483dc26b802922aed61c83cef58b.jpeg",
  wellness_villa:
    "https://static.prod-images.emergentagent.com/jobs/21ca7533-2233-4668-89c1-80c01499727b/images/83bda357d6c10b83b1513b8483ba5288c48aa1f9977fe020ca100d0d61cce612.jpeg",
  wine_cellar:
    "https://static.prod-images.emergentagent.com/jobs/21ca7533-2233-4668-89c1-80c01499727b/images/df27c7c3cfab20f9b624e73b1071a751f09084263bc6636e41bd4b1cff7060c5.jpeg",
  underground_bunker:
    "https://static.prod-images.emergentagent.com/jobs/7b96e313-38c8-4bd7-a3b9-9c258286bef3/images/5a85231abcf9d8b793bfb132e24ea5ba0758b54046a5c7d9cf66e3c3136b7b36.jpeg",
  site_map:
    "https://static.prod-images.emergentagent.com/jobs/7b96e313-38c8-4bd7-a3b9-9c258286bef3/images/484d64ccf44482eacf8e0cb0de8865e931f18cb22e99b781417679acaa629e2d.jpeg",
};

export const ACCESS_CODE = "SANLEONE2026";

export const GATE = {
  title: "SAN LEONE",
  subtitle: {
    it: "Deck riservato agli investitori",
    en: "Investor-only deck",
  },
  prompt: {
    it: "Inserisci il codice di accesso",
    en: "Enter your access code",
  },
  placeholder: { it: "Codice di accesso", en: "Access code" },
  submit: { it: "Entra", en: "Enter" },
  error: { it: "Codice non valido", en: "Invalid code" },
};

export const UI = {
  it: {
    langLabel: "IT",
    prev: "Precedente",
    next: "Successiva",
    export: "Esporta PDF",
    slideOf: (a, b) => `${a} / ${b}`,
  },
  en: {
    langLabel: "EN",
    prev: "Previous",
    next: "Next",
    export: "Export PDF",
    slideOf: (a, b) => `${a} / ${b}`,
  },
  ar: {
    langLabel: "AR",
    prev: "السابق",
    next: "التالي",
    export: "تصدير PDF",
    slideOf: (a, b) => `${a} / ${b}`,
  },
};

export const SLIDES = [
  {
    id: "cover",
    layout: "cover",
    image: IMAGES.cover_hero,
    kicker: { it: "Sardegna", en: "Sardinia, Italy", ar: "سردينيا، إيطاليا" },
    title: "SAN LEONE",
    subtitle: {
      it: "Longevity Ecosystem & Medical Retreat",
      en: "Longevity Ecosystem & Medical Retreat",
      ar: "منظومة طول العمر والملاذ الطبي",
    },
    tagline: {
      it: "Dove l'archeologia industriale rinasce come capitale della longevità",
      en: "Where industrial heritage is reborn as the capital of longevity",
      ar: "حيث يولد التراث الصناعي من جديد كعاصمة لطول العمر",
    },
  },
  {
    id: "vision",
    layout: "split-right",
    image: IMAGES.masterplan_mood,
    num: "01",
    section: { it: "La Visione", en: "The Vision", ar: "الرؤية" },
    body: {
      it: "Trasformare un sito di 470 ettari — 27 ettari di complesso minerario dismesso e il resto parco naturale — in una destinazione di lusso al mondo dedicata a longevità, benessere e ricerca — integrata con la natura del Gutturu Mannu e con la reputazione della Sardegna come Blue Zone.",
      en: "Turning a 470-hectare site — a 27-hectare disused mining complex surrounded by natural park — into a world-class luxury destination for longevity, wellness and research — integrated with the Gutturu Mannu nature and Sardinia's status as a Blue Zone.",
      ar: "تحويل موقع من 470 هكتاراً — 27 هكتاراً من مجمّع تعديني مهجور تحيط به محمية طبيعية — إلى وجهة فاخرة عالمية المستوى لطول العمر والعافية والبحث العلمي، متكاملة مع طبيعة غوتّورو مانّو ومكانة سردينيا كمنطقة زرقاء.",
    },
    highlights: [
      { it: "470 ettari complessivi", en: "470 hectares overall", ar: "470 هكتاراً إجمالاً" },
      {
        it: "Longevità · Benessere · Ricerca",
        en: "Longevity · Wellness · Research",
        ar: "طول العمر · العافية · البحث",
      },
      { it: "Blue Zone della Sardegna", en: "Sardinia Blue Zone", ar: "المنطقة الزرقاء في سردينيا" },
    ],
  },
  {
    id: "site",
    layout: "full-overlay",
    image: IMAGES.site_current,
    num: "02",
    section: { it: "Il Sito Oggi", en: "The Site Today", ar: "الموقع اليوم" },
    facts: [
      {
        value: "470 ha",
        it: "area complessiva — 27 ha di miniera, 443 ha di parco naturale",
        en: "total site — 27 ha mining area, 443 ha natural park",
        ar: "المساحة الإجمالية — 27 هكتاراً منطقة تعدين، 443 هكتاراً محمية طبيعية",
      },
      {
        value: "20+ km",
        it: "gallerie sotterranee",
        en: "underground galleries",
        ar: "أنفاق تحت الأرض",
      },
      {
        value: "3,5 mln m³",
        it: "materiale di risulta",
        en: "residual material",
        ar: "مواد متبقية",
      },
      {
        value: "4",
        it: "edifici storici da restaurare — Villa Rosa, Albergo Operai, Hangar, Chiesa di Santa Marta",
        en: "historic buildings to restore — Villa Rosa, Workers' Lodge, Hangar, Santa Marta Church",
        ar: "مبانٍ تاريخية للترميم — فيلا روزا، نزل العمال، الهنغار، كنيسة سانتا مارتا",
      },
    ],
  },
  {
    id: "sitemap",
    layout: "sitemap",
    image: IMAGES.site_map,
    num: "03",
    section: { it: "La Mappa del Sito", en: "Site Map", ar: "خريطة الموقع" },
    body: {
      it: "470 ettari nel cuore del Gutturu Mannu: l'area mineraria occupa meno del 6% del sito — tutto il resto è parco naturale.",
      en: "470 hectares in the heart of Gutturu Mannu: the mining area takes up less than 6% of the site — everything else is natural park.",
      ar: "470 هكتاراً في قلب غوتّورو مانّو: منطقة التعدين تشغل أقل من 6% من الموقع — وكل ما تبقى محمية طبيعية.",
    },
    legend: [
      { swatch: "park", value: "443 ha", it: "Parco naturale", en: "Natural park", ar: "محمية طبيعية" },
      { swatch: "mine", value: "27 ha", it: "Area mineraria", en: "Mining area", ar: "منطقة التعدين" },
      {
        swatch: "tunnel",
        value: "20+ km",
        it: "Gallerie sotterranee",
        en: "Underground galleries",
        ar: "أنفاق تحت الأرض",
      },
    ],
    scaleNote: {
      it: "Proporzione reale: miniera = 5,7% dei 470 ha",
      en: "True proportion: mine = 5.7% of 470 ha",
      ar: "النسبة الحقيقية: المنجم = 5.7% من 470 هكتاراً",
    },
    mapLabels: {
      park: {
        it: "Parco naturale — 443 ha",
        en: "Natural park — 443 ha",
        ar: "محمية طبيعية — 443 هكتاراً",
      },
      mine: { it: "Miniera — 27 ha", en: "Mine — 27 ha", ar: "المنجم — 27 هكتاراً" },
    },
    earthLink: "https://earth.google.com/web/@39.176,8.931,250a,3500d,35y,0h,0t,0r",
    earthLabel: {
      it: "Apri il sito su Google Earth",
      en: "Open the site on Google Earth",
      ar: "افتح الموقع على Google Earth",
    },
  },
  {
    id: "opportunity",
    layout: "split-left",
    image: IMAGES.bluezone_mood,
    num: "04",
    section: { it: "L'Opportunità", en: "The Opportunity", ar: "الفرصة" },
    body: {
      it: "Wellness tourism di lusso, longevità/anti-aging e medical tourism: mercati in forte crescita. La Sardegna è una delle 5 Blue Zone al mondo — un asset narrativo e scientifico unico e non replicabile.",
      en: "Luxury wellness tourism, longevity/anti-aging and medical tourism are high-growth markets. Sardinia is one of the world's 5 Blue Zones — a unique, non-replicable scientific and narrative asset.",
      ar: "سياحة العافية الفاخرة وطول العمر ومكافحة الشيخوخة والسياحة الطبية: أسواق تنمو بقوة. سردينيا واحدة من خمس مناطق زرقاء في العالم — أصل علمي وسردي فريد لا يمكن تكراره.",
    },
    highlights: [
      { it: "Wellness tourism di lusso", en: "Luxury wellness tourism", ar: "سياحة عافية فاخرة" },
      { it: "Longevità & anti-aging", en: "Longevity & anti-aging", ar: "طول العمر ومكافحة الشيخوخة" },
      { it: "Medical tourism", en: "Medical tourism", ar: "السياحة الطبية" },
      {
        it: "1 delle 5 Blue Zone al mondo",
        en: "1 of the world's 5 Blue Zones",
        ar: "واحدة من 5 مناطق زرقاء في العالم",
      },
    ],
  },
  {
    id: "concept",
    layout: "pillars",
    image: IMAGES.masterplan_mood,
    num: "05",
    section: { it: "Il Concept", en: "The Concept", ar: "المفهوم" },
    intro: {
      it: "Un ecosistema integrato in cinque pilastri.",
      en: "An integrated ecosystem across five pillars.",
      ar: "منظومة متكاملة عبر خمس ركائز.",
    },
    pillars: [
      {
        it: "Clinica longevità & ricerca",
        en: "Longevity clinic & research",
        ar: "عيادة طول العمر والبحث",
      },
      {
        it: "Boutique hotel & spa sotterranea",
        en: "Boutique hotel & underground spa",
        ar: "فندق بوتيكي وسبا تحت الأرض",
      },
      { it: "Ville wellness private", en: "Private wellness villas", ar: "فلل عافية خاصة" },
      {
        it: "Cantine sotterranee & enoturismo",
        en: "Underground wine cellars & wine tourism",
        ar: "أقبية نبيذ تحت الأرض وسياحة نبيذ",
      },
      {
        it: "Restauro filologico + bonifica a impatto zero",
        en: "Philological restoration + zero-impact remediation",
        ar: "ترميم فيلولوجي + معالجة بيئية بدون أثر",
      },
    ],
  },
  {
    id: "clinic",
    layout: "split-right",
    image: IMAGES.longevity_clinic,
    num: "06",
    section: { it: "Clinica Longevità", en: "Longevity Clinic", ar: "عيادة طول العمر" },
    body: {
      it: "Medicina predittiva, diagnostica avanzata, riabilitazione robotica, terapie iperbariche e un centro di ricerca sui biomarcatori dell'invecchiamento.",
      en: "Predictive medicine, advanced diagnostics, robotic rehabilitation, hyperbaric therapies and an aging-biomarker research center.",
      ar: "طب تنبؤي، تشخيص متقدم، إعادة تأهيل روبوتية، علاجات بالأكسجين عالي الضغط، ومركز أبحاث للمؤشرات الحيوية للشيخوخة.",
    },
    highlights: [
      { it: "Medicina predittiva", en: "Predictive medicine", ar: "الطب التنبؤي" },
      { it: "Diagnostica avanzata", en: "Advanced diagnostics", ar: "تشخيص متقدم" },
      { it: "Riabilitazione robotica", en: "Robotic rehabilitation", ar: "إعادة تأهيل روبوتية" },
      { it: "Terapie iperbariche", en: "Hyperbaric therapies", ar: "علاجات الأكسجين عالي الضغط" },
      { it: "Centro biomarcatori", en: "Biomarker research center", ar: "مركز المؤشرات الحيوية" },
    ],
  },
  {
    id: "hotel-spa",
    layout: "split-two-img",
    images: [IMAGES.boutique_hotel, IMAGES.underground_spa],
    num: "07",
    section: {
      it: "Hotel & Spa Sotterranea",
      en: "Boutique Hotel & Underground Spa",
      ar: "فندق بوتيكي وسبا تحت الأرض",
    },
    body: {
      it: "Hotel di lusso negli edifici industriali restaurati; spa termale nelle gallerie sotterranee — idroterapia, speleoterapia e meditazione, in un microclima naturalmente stabile.",
      en: "Luxury hotel within the restored industrial buildings; thermal spa inside the underground galleries — hydrotherapy, speleotherapy and meditation in a naturally stable microclimate.",
      ar: "فندق فاخر داخل المباني الصناعية المرمّمة؛ سبا حراري داخل الأنفاق — علاج مائي وعلاج بالكهوف وتأمّل في مناخ مصغّر مستقر طبيعياً.",
    },
  },
  {
    id: "villas",
    layout: "split-left",
    image: IMAGES.wellness_villa,
    num: "08",
    section: { it: "Ville Wellness", en: "Wellness Villas", ar: "فلل العافية" },
    body: {
      it: "Ville private in bio-architettura con tecnologia \u201cLongevity Smart Home\u201d per il monitoraggio della salute e programmi personalizzati.",
      en: "Private bio-architecture villas with \u201cLongevity Smart Home\u201d tech for health monitoring and personalized programs.",
      ar: "فلل خاصة بعمارة حيوية مزوّدة بتقنية «المنزل الذكي لطول العمر» لمراقبة الصحة وبرامج مخصّصة.",
    },
    callout: {
      it: "Motore immobiliare del progetto: vendita e affitto finanziano il grosso della costruzione.",
      en: "The project's real-estate engine: sales and leases fund most of the build.",
      ar: "المحرك العقاري للمشروع: البيع والتأجير يموّلان معظم البناء.",
    },
  },
  {
    id: "wine",
    layout: "split-right",
    image: IMAGES.wine_cellar,
    num: "09",
    section: {
      it: "Cantine & Enoturismo",
      en: "Wine Cellars & Wine Tourism",
      ar: "أقبية النبيذ وسياحة النبيذ",
    },
    body: {
      it: "Cantine d'\u00e9lite nelle gallerie: clima stabile ideale per l'affinamento, cantine private per i membri ed esperienze di degustazione esclusive.",
      en: "Elite cellars in the galleries: stable climate ideal for aging, private member cellars and exclusive tastings.",
      ar: "أقبية نخبوية داخل الأنفاق: مناخ مستقر مثالي للتعتيق، أقبية خاصة للأعضاء وتجارب تذوق حصرية.",
    },
    callout: {
      it: "Ricavo ancillare ricorrente.",
      en: "Recurring ancillary revenue.",
      ar: "إيراد إضافي متكرر.",
    },
  },
  {
    id: "business-model",
    layout: "dual-engine",
    num: "10",
    section: {
      it: "Business Model: Motore Triplo",
      en: "Business Model: Triple Engine",
      ar: "نموذج الأعمال: محرك ثلاثي",
    },
    engines: [
      {
        tag: { it: "Motore 1", en: "Engine 1", ar: "المحرك 1" },
        title: { it: "Cassa iniziale", en: "Initial cash", ar: "السيولة الأولية" },
        body: {
          it: "Estrazione da ripristino ambientale: 100.000 ton/anno di materiale micronizzato venduto a $350/ton.",
          en: "Environmental-restoration extraction: 100,000 tons/year of micronized material sold at $350/ton.",
          ar: "استخراج من إعادة التأهيل البيئي: 100,000 طن/سنة من المواد المطحونة تُباع بسعر 350$ للطن.",
        },
      },
      {
        tag: { it: "Motore 2", en: "Engine 2", ar: "المحرك 2" },
        title: { it: "Finanziamento costruzione", en: "Build financing", ar: "تمويل البناء" },
        body: {
          it: "Vendita e affitto degli immobili ristrutturati.",
          en: "Sale & lease of the restored real estate.",
          ar: "بيع وتأجير العقارات المرمّمة.",
        },
      },
      {
        tag: { it: "Motore 3", en: "Engine 3", ar: "المحرك 3" },
        title: { it: "Ricavi ricorrenti", en: "Recurring revenue", ar: "إيرادات متكررة" },
        body: {
          it: "Clinica, hotel, spa e cantine.",
          en: "Clinic, hotel, spa and cellars.",
          ar: "العيادة والفندق والسبا والأقبية.",
        },
      },
    ],
  },
  {
    id: "numbers",
    layout: "numbers",
    num: "11",
    section: { it: "I Numeri", en: "The Numbers", ar: "الأرقام" },
    lead: {
      it: "Investimento richiesto",
      en: "Investment ask",
      ar: "الاستثمار المطلوب",
      value: "\u20ac30M",
      note: {
        it: "acquisto area + macchinari di estrazione",
        en: "site acquisition + extraction machinery",
        ar: "شراء الموقع + آلات الاستخراج",
      },
    },
    groups: [
      {
        title: {
          it: "Estrazione — ripristino ambientale",
          en: "Extraction — environmental restoration",
          ar: "الاستخراج — إعادة التأهيل البيئي",
        },
        rows: [
          {
            it: "Volume di estrazione",
            en: "Extraction volume",
            ar: "حجم الاستخراج",
            value: { it: "100.000 ton/anno", en: "100,000 tons/yr", ar: "100,000 طن/سنة" },
          },
          {
            it: "Prezzo di vendita",
            en: "Sale price",
            ar: "سعر البيع",
            value: "$350/ton",
          },
          {
            it: "Costi estrazione + trasporto + micronizzazione",
            en: "Extraction + transport + micronization costs",
            ar: "تكاليف الاستخراج + النقل + الطحن",
            value: "$35/ton",
          },
          {
            it: "Margine per tonnellata",
            en: "Margin per ton",
            ar: "الهامش للطن",
            value: "$315/ton",
          },
          {
            it: "Cassa da estrazione",
            en: "Cash from extraction",
            ar: "السيولة من الاستخراج",
            value: { it: "~$31,5M/anno", en: "~$31.5M/yr", ar: "~$31.5M سنوياً" },
            primary: true,
          },
        ],
      },
      {
        title: {
          it: "Immobiliare & ricavi",
          en: "Real estate & revenue",
          ar: "العقارات والإيرادات",
        },
        rows: [
          {
            it: "Prezzo di vendita ville",
            en: "Villa sale price",
            ar: "سعر بيع الفيلا",
            value: { it: "\u20ac30M l'una", en: "\u20ac30M each", ar: "\u20ac30M للواحدة" },
          },
          {
            it: "Costo di costruzione complessivo",
            en: "Total construction cost",
            ar: "تكلفة البناء الإجمالية",
            value: "\u20ac70M",
          },
          {
            it: "Valore di vendita resort",
            en: "Resort sale value",
            ar: "قيمة بيع المنتجع",
            value: "\u20ac100M",
            primary: true,
          },
          {
            it: "Ricavi extra ricorrenti",
            en: "Extra recurring revenue",
            ar: "إيرادات إضافية متكررة",
            value: { it: "Affitti", en: "Leases", ar: "إيجارات" },
            note: {
              it: "affitto spa + clinica/laboratorio",
              en: "spa + clinic/laboratory lease",
              ar: "إيجار السبا + العيادة/المختبر",
            },
          },
        ],
      },
    ],
  },
  {
    id: "cashflow",
    layout: "cashflow",
    num: "12",
    section: {
      it: "Flussi di Cassa — 5 Anni",
      en: "Cash Flow — 5 Years",
      ar: "التدفقات النقدية — 5 سنوات",
    },
    intro: {
      it: "Cassa cumulata da estrazione: 100.000 ton/anno × $315/ton di margine.",
      en: "Cumulative cash from extraction: 100,000 tons/yr × $315/ton margin.",
      ar: "السيولة التراكمية من الاستخراج: 100,000 طن/سنة × هامش 315$ للطن.",
    },
    maxValue: 157.5,
    bars: [
      {
        year: { it: "Anno 1", en: "Year 1", ar: "السنة 1" },
        value: 31.5,
        label: { it: "$31,5M", en: "$31.5M", ar: "$31.5M" },
      },
      {
        year: { it: "Anno 2", en: "Year 2", ar: "السنة 2" },
        value: 63,
        label: { it: "$63M", en: "$63M", ar: "$63M" },
      },
      {
        year: { it: "Anno 3", en: "Year 3", ar: "السنة 3" },
        value: 94.5,
        label: { it: "$94,5M", en: "$94.5M", ar: "$94.5M" },
      },
      {
        year: { it: "Anno 4", en: "Year 4", ar: "السنة 4" },
        value: 126,
        label: { it: "$126M", en: "$126M", ar: "$126M" },
      },
      {
        year: { it: "Anno 5", en: "Year 5", ar: "السنة 5" },
        value: 157.5,
        label: { it: "$157,5M", en: "$157.5M", ar: "$157.5M" },
      },
    ],
    milestones: [
      {
        time: { it: "Anno 3+", en: "Year 3+", ar: "السنة 3+" },
        it: "Vendita ville — €30M l'una",
        en: "Villa sales — €30M each",
        ar: "بيع الفلل — €30M للواحدة",
      },
      {
        time: { it: "Exit", en: "Exit", ar: "التخارج" },
        it: "Vendita resort — €100M",
        en: "Resort sale — €100M",
        ar: "بيع المنتجع — €100M",
      },
      {
        time: { it: "Ricorrenti", en: "Recurring", ar: "متكررة" },
        it: "Affitto spa + clinica/laboratorio",
        en: "Spa + clinic/laboratory lease",
        ar: "إيجار السبا + العيادة/المختبر",
      },
    ],
  },
  {
    id: "sustainability",
    layout: "full-overlay",
    image: IMAGES.site_current,
    desaturate: true,
    num: "13",
    section: {
      it: "Sostenibilità & Vincoli",
      en: "Sustainability & Regulatory",
      ar: "الاستدامة والقيود التنظيمية",
    },
    body: {
      it: "Approccio \u201cimpatto zero\u201d, restauro filologico e materiali locali.",
      en: "\u201cZero-impact\u201d approach, philological restoration and local materials.",
      ar: "نهج «بدون أثر بيئي»، ترميم فيلولوجي ومواد محلية.",
    },
    constraints: [
      { it: "Geoparco UNESCO", en: "UNESCO Geopark", ar: "جيوبارك اليونسكو" },
      { it: "PPR Sardegna", en: "Regional landscape plan", ar: "خطة المشهد الإقليمية" },
      { it: "Tutela storico-archeologica", en: "Heritage protection", ar: "حماية التراث" },
      { it: "Parco Gutturu Mannu", en: "Gutturu Mannu Park", ar: "منتزه غوتّورو مانّو" },
    ],
    footer: {
      it: "Dialogo precoce con Soprintendenza e Regione già in corso.",
      en: "Early dialogue with heritage and regional authorities already underway.",
      ar: "حوار مبكر جارٍ بالفعل مع هيئات التراث والسلطات الإقليمية.",
    },
  },
  {
    id: "roadmap",
    layout: "roadmap",
    num: "14",
    section: { it: "Roadmap", en: "Roadmap", ar: "خارطة الطريق" },
    phases: [
      {
        phase: { it: "Fase 0", en: "Phase 0", ar: "المرحلة 0" },
        time: { it: "0–12 mesi", en: "0–12 months", ar: "0–12 شهراً" },
        it: "Acquisto area, autorizzazioni, bonifica e messa in sicurezza, avvio estrazione.",
        en: "Site acquisition, permitting, remediation and securing, start of extraction.",
        ar: "شراء الموقع، التراخيص، المعالجة والتأمين، بدء الاستخراج.",
      },
      {
        phase: { it: "Fase 1", en: "Phase 1", ar: "المرحلة 1" },
        time: { it: "1–3 anni", en: "1–3 years", ar: "1–3 سنوات" },
        it: "Boutique hotel + spa sotterranea (primo revenue esperienziale).",
        en: "Boutique hotel + underground spa (first experiential revenue).",
        ar: "فندق بوتيكي + سبا تحت الأرض (أول إيراد من التجارب).",
      },
      {
        phase: { it: "Fase 2", en: "Phase 2", ar: "المرحلة 2" },
        time: { it: "3–5 anni", en: "3–5 years", ar: "3–5 سنوات" },
        it: "Ville wellness (vendita/affitto → finanzia la costruzione).",
        en: "Wellness villas (sale/lease → funds the build).",
        ar: "فلل العافية (بيع/تأجير ← تمويل البناء).",
      },
      {
        phase: { it: "Fase 3", en: "Phase 3", ar: "المرحلة 3" },
        time: { it: "4–6 anni", en: "4–6 years", ar: "4–6 سنوات" },
        it: "Clinica longevità & centro ricerca.",
        en: "Longevity clinic & research center.",
        ar: "عيادة طول العمر ومركز الأبحاث.",
      },
      {
        phase: { it: "Fase 4", en: "Phase 4", ar: "المرحلة 4" },
        time: { it: "6+ anni", en: "6+ years", ar: "6+ سنوات" },
        it: "Cantine, enoturismo ed espansione.",
        en: "Cellars, wine tourism and expansion.",
        ar: "الأقبية وسياحة النبيذ والتوسع.",
      },
    ],
  },
  {
    id: "ask",
    layout: "ask",
    image: IMAGES.cover_hero,
    num: "15",
    section: { it: "L'Ask & Contatti", en: "The Ask & Contact", ar: "الطلب والتواصل" },
    amount: "\u20ac30M",
    body: {
      it: "Cerchiamo \u20ac30M per l'acquisizione e l'avvio. Aperti a equity, partner strategici (cliniche, brand luxury, università) e co-sviluppo immobiliare.",
      en: "We are raising \u20ac30M for acquisition and start-up. Open to equity, strategic partners (clinics, luxury brands, universities) and real-estate co-development.",
      ar: "نجمع 30 مليون يورو للاستحواذ والانطلاق. منفتحون على المساهمة في رأس المال، والشركاء الاستراتيجيين (عيادات، علامات فاخرة، جامعات)، والتطوير العقاري المشترك.",
    },
    open: [
      { it: "Equity", en: "Equity", ar: "مساهمة رأسمالية" },
      { it: "Partner strategici", en: "Strategic partners", ar: "شركاء استراتيجيون" },
      {
        it: "Co-sviluppo immobiliare",
        en: "Real-estate co-development",
        ar: "تطوير عقاري مشترك",
      },
    ],
  },
  {
    id: "underground-assets",
    layout: "split-right",
    image: IMAGES.underground_bunker,
    num: "+",
    badge: {
      it: "Bonus · Appendice riservata",
      en: "Bonus · Confidential appendix",
      ar: "إضافي · ملحق سري",
    },
    section: { it: "Underground Assets", en: "Underground Assets", ar: "الأصول تحت الأرض" },
    body: {
      it: "Oltre 20 km di gallerie: bunker privati e safe room di lusso per clientela UHNW — sicurezza assoluta, microclima stabile e totale riservatezza. Offerta separata dal racconto wellness, solo su richiesta.",
      en: "Over 20 km of galleries: private bunkers and luxury safe rooms for UHNW clients — absolute security, stable microclimate and total privacy. Kept separate from the wellness narrative, available on request only.",
      ar: "أكثر من 20 كم من الأنفاق: ملاجئ خاصة وغرف آمنة فاخرة لعملاء من أصحاب الثروات الكبرى — أمان مطلق، مناخ مستقر وخصوصية تامة. عرض منفصل عن سردية العافية، متاح عند الطلب فقط.",
    },
    highlights: [
      {
        it: "Bunker privati & safe room",
        en: "Private bunkers & safe rooms",
        ar: "ملاجئ خاصة وغرف آمنة",
      },
      {
        it: "Sicurezza & privacy assoluta",
        en: "Absolute security & privacy",
        ar: "أمان وخصوصية مطلقة",
      },
      {
        it: "Microclima stabile naturale",
        en: "Naturally stable microclimate",
        ar: "مناخ مصغّر مستقر طبيعياً",
      },
      {
        it: "Clientela UHNW su invito",
        en: "Invitation-only UHNW clientele",
        ar: "عملاء UHNW بالدعوة فقط",
      },
    ],
    callout: {
      it: "Ricavo premium addizionale: vendita o locazione a lungo termine di unità blindate personalizzate.",
      en: "Additional premium revenue: sale or long-term lease of bespoke secured units.",
      ar: "إيراد إضافي مميز: بيع أو تأجير طويل الأمد لوحدات مؤمّنة حسب الطلب.",
    },
  },
];
